<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
          <v-card-title>
            Courses
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              @input="getDataFromApi()"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            
            <v-spacer></v-spacer>
            <v-btn
            class="mx-2"
            fab
            dark
            color="primary"
            @click="addNew"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="list"
            :options.sync="options"
            :items-per-page="itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:item.status="{ item }">
                <v-icon v-if="item.status == 1" color="success">mdi-check</v-icon>
                <v-icon v-if="item.status == 0" color="error">mdi-close-circle-outline</v-icon>
            </template> 

            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="edit(item.id)"
                >
                    mdi-pencil
                </v-icon>
                <a 
                    :href="'/course/'+item.alias" target="_blank">
                    <v-icon
                    small
                    class="mr-2"
                    
                    >
                    mdi-eye
                    </v-icon>
                </a>
            
            </template>
        </v-data-table>
        </v-card> 

        <v-dialog v-model="dialogAdd"  fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialogAdd = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="dialogType == 'add'">Add New Course</v-toolbar-title>
          <v-toolbar-title v-if="dialogType == 'edit'">Edit {{newcourse.name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                v-if="dialogType=='add'"
              dark
              text
              @click="saveAddDialog"
            >
              Add
            </v-btn>
            <v-btn
                v-if="dialogType=='edit'"
              dark
              text
              @click="saveEditDialog"
            >
              Update
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container v-if="errors">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-alert type="error">
                      <ul>
                        <li v-for="e in errors">
                          {{ e[0] }}
                        </li>
                      </ul>
                      
                    </v-alert>
                  </v-col>
                </v-row>
              </v-container>
        <v-container>
                <v-row>
                  
                  <v-col cols="12" sm="12">
                    <p class="text-h4">Basic Information</p>
                  </v-col>
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-switch
                      v-model="newcourse.status"
                      label="Active"
                    ></v-switch>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                  <v-autocomplete
                      v-model="newcourse.organization_id"
                      label="Organization*"
                      :items="organizations"
                      item-text="name"
                      item-value="id"
                      clearable
                      required
                      v-on:change="orgChange"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                  <v-autocomplete
                      v-model="newcourse.category_id"
                      label="Category*"
                      :items="categories"
                      item-text="title"
                      item-value="id"
                      clearable
                      required
                    ></v-autocomplete>
                  </v-col>
                  
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.title"
                      label="Title*"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.course_link"
                      label="Url"
                      prepend-icon="mdi-link"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-select
                      v-model="newcourse.location"
                      :items="['Online','In-person']"
                      label="Location"
                      required
                    ></v-select>
                  </v-col>
                  
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                  <p>Description</p>
                  <vue-editor
                      v-model="newcourse.description"
                      label="Description"
                    ></vue-editor>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                  <p>Course Content</p>
                    <vue-editor
                        v-model="newcourse.course_content"
                        label="Course Content"
                      ></vue-editor>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <p>Entry Requirements</p>
                    <vue-editor
                        v-model="newcourse.entry_requirements"
                        label="Entry Requirements"
                      ></vue-editor>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <p>Learning Outcomes</p>
                    <vue-editor
                        v-model="newcourse.learning_outcomes"
                        label="Learning Outcomes"
                      ></vue-editor>
                  </v-col>
                </v-row>
                <hr/>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h4">Optional Information</p>
                  </v-col>
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <p>Awarding Body</p>
                    <vue-editor
                        v-model="newcourse.awarding_body"
                        label="Awarding Body"
                      ></vue-editor>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Address</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-select
                      v-model="newcourse.region"
                      label="Region"
                      :items="regions"
                      clearable
                    ></v-select>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.address"
                      label="Address"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.postal_code"
                      label="Postal Code"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Contact Information</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.contact_email"
                      label="Contact Email"
                      clearable
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.contact_phone"
                      label="Contact Phone"
                      clearable
                    ></v-text-field>
                </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Other Information</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.duration"
                      label="Course Duration"
                      clearable
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                  <v-menu
                      ref="start_date_menu"
                      v-model="start_date_menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="newcourse.start_date"
                          label="Start date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="newcourse.start_date"
                        min="2023-01-01"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.timetable"
                      label="Timetable"
                      persistent-hint
                      placeholder="2 hours a day, MWF"
                      hint="How is the course scheduled?"
                      clearable
                    ></v-text-field>
                </v-col>
                </v-row>
              </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddDialog"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="dialogType == 'add'"
                color="blue darken-1"
                text
                @click="saveAddDialog"
              >
                Add New
              </v-btn>
              <v-btn
                v-if="dialogType == 'edit'"
                color="blue darken-1"
                text
                @click="saveEditDialog"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" >
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete = !dialogDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import axios from 'axios'
  import { VueEditor } from "vue2-editor";
  
  const passwordLength = 12
  const passwordChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

  export default {
    props: {
      courses: Array,
      organizations:Array,
      categories:Array,
      regions:Array,
      baseurl:String,
    },
    components: {
      Head,
      VueEditor
    },
    layout: Layout,
    data() {
        return {
          start_date_menu: null,
            list: [],
            keyword: "",
            location: "",
            category: "",
            total: this.courses.length,
            itemsPerPage: 20,
            loading: false,
            loadingAdd: false,
            options: {},
            search: "",
            headers: [
              { text: 'ID', value:'id'},
              { text: 'Title', value:'title'},
              { text: 'Active', value:'status'},
              { text: 'Organization', value:'organization.name'},
              { text: 'Actions', value:'actions'}

            ],
            newcourse: {
              title:"",//
              organization_id: "",//
              category_id: "",//
              
              description: "",//
              status: false,
              is_featured:false,
              address: "",//
              city: "",//
              region: "",//
              country: "IE",//
              postal_code: "",//
              
              location: "",
              duration: "",
              contact_email:"",
              contact_phone:"",
              entry_requirements:"",
              course_content:"",
              awarding_body: "",
              start_date:"",
              timetable:"",
              course_link:""
            },
            errors:false,
            dialogType:'add',
            dialogAdd: false,
            dialogDelete: false
        }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    created() {
      this.list = JSON.parse(JSON.stringify(this.courses));
    },
    methods: {
      setDefaultOrg() {
        console.log('set default org',this.organizations)
        if (this.organizations.length == 1)
        {
          this.newcourse.organization_id = this.organizations[0].id
          this.orgChange(this.newcourse.organization_id)
        }  
      },
      orgChange(o) {
        console.log('org changed',o)
        var result = this.organizations.filter(obj => {
          return obj.id === o
        });
        if (result && result[0])
        {
          let org = result[0]
          this.newcourse.city = org.city
          this.newcourse.region = org.region
          this.newcourse.postal_code = org.postal_code
          this.newcourse.contact_email = org.email
          this.newcourse.contact_phone = org.phone

          console.log('found',org)
        }
      },
      suggestTags() {
        const formData = new FormData()
        Object.keys(this.newcourse).forEach(key => formData.append(key, this.newcourse[key]));


        axios.post("/admin/courses/suggestTags",formData).then((response) => {
            console.log('suggest tags got response',response.data)
            if (response && response.data)
            {
                this.newcourse.tags = [...new Set([...this.newcourse.tags, ...response.data])]  
            }
        });
      },
      addTag() {
        if (this.newtag)
          this.newcourse.tags.push(this.newtag);
      },
      edit(id) {
        console.log('attempting to edit id ',id)
        axios.get(this.baseurl+"/provider/get/"+id).then((response) => {
            console.log('edit got response',response.data)
            if (response && response.data)
            {
                this.newcourse = response.data
                if (this.newcourse.status)
                  this.newcourse.status = true;
                if (this.newcourse.is_featured)
                  this.newcourse.is_featured = true;
                if (this.newcourse.tag_strings && this.newcourse.tag_strings.length)
                {
                  this.newcourse.tags = this.newcourse.tag_strings
                }

                this.dialogAdd = true;
                this.dialogType='edit';
            }
        });
      },
      addNew(){
        this.dialogType='add';
        Object.keys(this.newcourse).forEach(key => {
            if (key == 'photo')
                this.newcourse.key = []
            else
                this.newcourse[key] = "";
        });
        this.setDefaultOrg();
        this.dialogAdd = true;
      },
      getDataFromApi () {
        this.loading = true
        console.log('getting request',this.options)
        var params = JSON.parse(JSON.stringify(this.options));
        params.filters = { search: this.search, role: this.role };

        axios.get(this.baseurl+"/provider/list",{ params: params }).then((response) => {
          this.list = response.data.list
          this.total= response.data.total;
          this.loading = false;
        });
      },
      deleteItemConfirm () {
        this.closeDelete()
      },

      closeAddDialog () {
        this.dialogAdd = false
      },

      closeDelete () {
        this.dialogDelete = false
        
      },
      saveEditDialog () {
        this.loadingAdd=true;
        this.errors=false;
        const formData = new FormData()
        Object.keys(this.newcourse).forEach(key => formData.append(key, this.newcourse[key]));
        axios.post(this.baseurl+"/provider/update",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Edit failed');
          
            console.log('edit response',response)
            this.loadingAdd = false;
        }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      saveAddDialog () {
        this.loadingAdd=true;
        this.errors=false;
        console.log('adding course',this.newcourse)
        const formData = new FormData()
        Object.keys(this.newcourse).forEach(key => formData.append(key, this.newcourse[key]));
        axios.post(this.baseurl+"/provider/add",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Add failed');
          
            console.log('add response',response)
          this.loadingAdd = false;
        }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      
    },
  }
  </script>
  